function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useState } from 'react';
import { Tabs, Typography } from 'antd';
import { buildSample } from '@cryptosheets/util';
import Operations from './Operations';
import { CodeBoxActions, ResourceWrapper } from './index.style';
import Info from './Info';
var {
  TabPane
} = Tabs;
var {
  Paragraph,
  Text
} = Typography;
var options = [{
  label: 'API',
  value: 'web'
}, {
  label: 'Excel',
  value: 'excel'
}, {
  label: 'Google Sheets',
  value: 'sheets'
}];
var testData = {
  endpoint: {},
  // OPTIONAL,
  customFunction: 'QUERYA',
  listSeperator: ',',
  // ",", ";", see https://exceljet.net/glossary/list-separator#:~:text=By%20default%2C%20Excel%20uses%20the,may%20use%20a%20semicolon%20(%3B).&text=Note%3A%20Excel%20automatically%20translates%20the%20separator%20in%20many%20cases.
  as: 'string',
  // "string", "R1C1", "A1"
  value: {
    provider: 'Messari',
    endpoint: 'Get Asset Timeseries',
    assetKey: 'btc',
    metricID: 'price',
    start: '2020-01-01',
    end: '2020-02-01',
    interval: '1d',
    columns: 'close',
    _limit: 1,
    _fields: '1',
    _showHeaders: false
  }
};
var NO_RESOURCE = 'Function template not yet implemented.';

var CodeSamples = (_ref) => {
  var {
    type = 'excel',
    config = testData
  } = _ref;
  var [activeKey, setActiveKey] = useState(type);
  var [resource, setResource] = useState(null);
  var [listSeperator, setListSeperator] = useState(false);
  var [infoDrawerVisible, setInfoDrawerVisible] = useState(false);
  var [genConfig, setGenConfig] = useState({});
  useEffect(() => {
    var functionConfig = config;

    if (listSeperator) {
      functionConfig = _objectSpread(_objectSpread({}, functionConfig), {}, {
        listSeperator: ';'
      });
    }

    var sample = buildSample(activeKey, functionConfig);
    setResource(sample);
    setGenConfig(functionConfig);
  }, [activeKey, config, listSeperator]);
  var operationProps = {
    config: genConfig,
    resource,
    activeKey,
    listSeperator,
    setListSeperator,
    setInfoDrawerVisible
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tabs, {
    activeKey: activeKey,
    onChange: key => setActiveKey(key) // tabBarExtraContent={<Operations />}

  }, options.map((_ref2, index) => {
    var {
      label,
      value
    } = _ref2;
    return /*#__PURE__*/React.createElement(TabPane, {
      tab: label,
      key: value,
      style: {
        overflowWrap: 'anywhere'
      }
    }, /*#__PURE__*/React.createElement(ResourceWrapper, null, /*#__PURE__*/React.createElement(Text, {
      strong: true
    }, resource || NO_RESOURCE)), /*#__PURE__*/React.createElement(CodeBoxActions, null, /*#__PURE__*/React.createElement(Operations, operationProps)));
  })), /*#__PURE__*/React.createElement(Info, {
    closeDrawer: () => setInfoDrawerVisible(false),
    drawerVisible: infoDrawerVisible
  }));
};

export default CodeSamples;